import { ExplorationSnapshot } from 'features/drilldown/data/savedExplorationState/explorationMutation'

import { ChatMessageResponse, SendMessageArgs } from './gongChatApi'

type SendExplorerChatTurnArgs = {
  orgId: string
  sessionId?: string
  content: string
  unitIds: ReadonlyArray<string>
  clientContext: string
  requestId: string
  buildCurrentSnapshot: () => ExplorationSnapshot | undefined
  ensureSession: (orgId: string) => Promise<string>
  sendMessage: (args: SendMessageArgs) => Promise<ChatMessageResponse>
  onSessionCreated?: (sessionId: string) => void
}

type SentExplorerChatTurn = {
  sessionId: string
  response: ChatMessageResponse
}

export const sendExplorerChatTurn = async ({
  orgId,
  sessionId,
  content,
  unitIds,
  clientContext,
  requestId,
  buildCurrentSnapshot,
  ensureSession,
  sendMessage,
  onSessionCreated,
}: SendExplorerChatTurnArgs): Promise<SentExplorerChatTurn> => {
  const currentSessionId = sessionId ?? (await ensureSession(orgId))
  if (!sessionId) onSessionCreated?.(currentSessionId)
  const explorationSnapshot = buildCurrentSnapshot()
  const response = await sendMessage({
    sessionId: currentSessionId,
    content,
    unitIds,
    clientContext,
    explorationSnapshot,
    requestId,
    enablePanelCreation: true,
  })
  return { sessionId: currentSessionId, response }
}
